<template lang="pug">
.opener(@click="click")
  .border
  .toggle-robo
    .bars
      .bar.tall.gap
      .bar
      .bar
      .bar.tall
      .bar.gap
      .bar.tall
      .bar
      .bar.tall
      .bar.tall
    .eyes
      .eye
      .eye
  .lines
    .line
    .line
    .line
    .line
    .line
    .line
    .label view report
</template>
<script>
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
export default {
  name: 'rropener',
  computed: {
    ...mapGetters(['chartShown', 'watchlistShown']),
    ...vuexComputed('roboReportShown')
  },
  methods: {
    async click() {
      await (this.selectedWatchlistThemes = {});
      await (this.watchlistThemesParentFilter = '');
      const { chartShown, watchlistShown } = this;
      this.roboReportLaunchedFromWatchList = watchlistShown && !chartShown;
      this.roboReportShown = true;
      this.$emit('click');
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/global';
.opener {
  z-index: 5;
  position: relative;
  top: -1.125rem;
  &:not(.small) {
    position: absolute;
    top: 0;
    right: 5rem;
    &:hover {
      transform: scale(0.8);
    }
  }
  cursor: pointer;
  font-size: 1.25rem;
  width: 3rem;
  height: 4.5rem;
  //border: 2px solid #ccc;
  border-radius: 0.25rem;
  background-color: white;
  transform: scale(0.7);
  transform-origin: center;
  //transform: rotate(7deg);
  //height: 2rem;
  //position: relative;
  transition: transform 150ms ease-in-out;
  will-change: transform;
  &.small {
    transform: scale(0.37);
    //&:hover {
    //  transform: scale(0.6);
    //}
  }
  & > .border,
  &::before,
  &::after {
    //& > .border {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: 1px solid #bcbcbc;
    border-radius: 0.25rem;
    z-index: -1;
    transform: rotate(12deg);
    background-color: white;
    transform-origin: center 70%;
  }
  & > .border {
    //background-color: transparent;
    z-index: 3;
    transform: none;
    border-color: #989898;
    //background-color: transparent;
  }
  &::after {
    transform: translate3d(2px, 0, 0) rotate(7deg);
    transform-origin: center 30%;
    //background-color: transparent;
  }
  .lines {
    content: '';
    position: absolute;
    top: 2.2rem;
    left: 10%;
    width: 80%;
    z-index: 4;
    display: grid;
    grid-template-rows: repeat(6, 1fr);
    grid-row-gap: 0.25rem;
    //background-color: #eee;
    & > .line {
      height: 1px;
      background-color: #ababab;
    }
  }
  &:hover {
    border-color: #444;
  }
  &.small {
    .label {
      transform: scale(2) translate3d(-25%, 0.6rem, 0);
    }
  }
  .label {
    position: absolute;
    top: 3rem;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    font-size: 0.9rem;
    color: $brn;
    opacity: 0;
    white-space: nowrap;
    transition: opacity 250ms ease-in-out;
    will-change: opacity;
  }
  &:hover {
    .label {
      opacity: 1 !important;
    }
  }
  & > .toggle-robo {
    position: absolute;
    top: 0.5rem;
    left: 0.46rem;
    width: 1.25rem;
    height: 1.25rem;
    z-index: 4;
    background-color: $brn;
    border-radius: 0.25rem;
    overflow: hidden;
    .eyes {
      position: absolute;
      top: 0.25rem;
      left: 0;
      right: 0;
      display: flex;
      justify-content: space-evenly;
      .eye {
        width: 0.25rem;
        height: 0.25rem;
        background-color: white;
        border: 1px solid #282828;
        border-radius: 50%;
        & + .eye {
          background-color: orange;
        }
      }
    }
    .bars {
      position: absolute;
      width: 50%;
      left: 50%;
      .bar {
        padding-top: 0;
        height: 1px;
        background-color: white;
        margin-top: 1px;
        &.tall {
          height: 2px;
        }
        &.gap {
          margin-bottom: 2px;
        }
      }
    }
  }
}
</style>
